module.exports = __webpack_public_path__ + "img/businessOne.a7a29a44.svg";